export const formatStringToDate = (dateString: string) => {
  if (dateString) return new Date(dateString);
  else return null;
};
